import { mapObjIndexed, concat } from "ramda";

const orderByDistance = (offices) => {
	if (!offices.length) return;
	let objToSet = {};
	const lastArray = [];
	const infiArray = [];
	const repeatDistance = [];
	offices.forEach((el) => {
		if (
			el.distance &&
			el.distance.distance &&
			el.distance.distance !== Infinity
		) {
			const keys = Object.keys(objToSet);
			const distanceToSet = Math.trunc(el.distance.distance);
			if (keys && keys.length) {
				const alreadyExist = keys.includes(distanceToSet.toString());
				if (alreadyExist) {
					repeatDistance.push(el);
					return;
				}
			}
			objToSet[Math.trunc(el.distance.distance)] = el;
		} else {
			infiArray.push(el);
		}
	});
	mapObjIndexed((value) => lastArray.push(value), objToSet);

	const officesByDistance = lastArray.sort();
	const list = concat(officesByDistance, infiArray);
	const lastList = concat(list, repeatDistance);
	return lastList;
};
export { orderByDistance };
